export const accountModeMap = {
  SRO: 'SRO',
  SRO_LIGHT: 'SRO Lite',
  SELF_PLANNED: 'Self Planned',
}
